import { Alert, Card, CardHeader, Divider, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Box } from '@mui/system';
import { makeStyles } from 'tss-react/mui';
import { useCanChangeSicNumber } from '../../../sic-lib/api/hooks/useTwilio';
import { EditUserTwilioPhoneData } from '../../../sic-lib/types/EditUserTwilioPhoneData';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';
import Loader from '../../Shared/Loader';
import { AvailableNumbersForm } from './AvailableNumbersForm';

type Props = {
    phoneSettings: EditUserTwilioPhoneData;
};

export function ChangeSicNumberForm({ phoneSettings }: Props) {
    const { classes } = useStyles();

    const { data: canChangeNumber, isLoading } = useCanChangeSicNumber();

    return (
        <>
            {!!phoneSettings.number && (
                <Card className={classes.paper}>
                    <CardHeader title="Change my StayInContact Number" />
                    <Divider />
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            display="flex"
                            flexDirection="column"
                            alignContent="center"
                            justifyContent="center"
                        >
                            <Box p={2} className={classes.phoneWrap}>
                                <Typography variant="subtitle1">
                                    My StayInContact Phone Number
                                </Typography>
                                <Typography variant="h6">
                                    <DisplayPhoneNumber phoneNumber={phoneSettings.number} />
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Card>
            )}
            <Loader isLoading={isLoading}>
                <>
                    {!canChangeNumber && (
                        <Alert severity="warning">
                            You can have reached the maximum number of changes to your StayInContact
                            number. Please contact Support if you wish to change it again.
                        </Alert>
                    )}
                    {canChangeNumber && <AvailableNumbersForm />}
                </>
            </Loader>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        marginBottom: theme.spacing(2),
    },
    phoneWrap: {
        textAlign: 'center',
    },
}));
